<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses, { 'app-page': isAppPage }]">
    <vx-sidebar :sidebarItems="sidebarItemsPropParent" :logo="require('@/assets/images/logo/logo.png')" title="Nitro Panel" parent=".layout--main" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar :navbarColor="navbarColor" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" />

        <div class="router-view">
          <div class="router-content" :class="{ 'mt-0': navbarType == 'hidden' }" style="margin-top:4rem!important">
            <div class="content-area__content">
              <back-to-top bottom="10%" visibleoffset="250" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from "@/layouts/components/vx-sidebar/VxSidebar.vue";
import TheNavbar from "../components/TheNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import sidebarItems from "@/layouts/components/vx-sidebar/sidebarItems.js";
import BackToTop from "vue-backtotop";

export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || "floating",
      navbarColor: themeConfig.navbarColor || "#fff",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItemsPropParent: [],
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      if (this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    },
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },

    GetSidebarItemList: async function() {
      if (this.$store.state.userData.userType == "ErpUser") {
        this.sidebarItemsPropParent = sidebarItems;
      } else {
        let sidebarFilteredList = [];
        sidebarItems.forEach((r) => {
          if (r.url != null && this.$store.state.userData.routerList.find((u) => u.routerName == r.url.replace("/", ""))) {
            let subList = [];
            if (r.submenu) {
              r.submenu.forEach((t) => {
                if (t.url != null && this.$store.state.userData.routerList.find((u) => u.routerName == t.url.replace("/", ""))) {
                  subList.push(t);
                }
              });
              r.submenu = subList;
            }
            sidebarFilteredList.push(r);
          }
        });
        this.sidebarItemsPropParent = sidebarFilteredList;
        ///

        // for(let i=0;i<sidebarItems.length;i++){
        //   console.log("sss",sidebarItems[i])
        //   if(sidebarItems[i].submenu)
        //   for(let x=0;x<sidebarItems[i].submenu.length;x++)
        //   {

        //     if(sidebarItems[i].submenu[x].url!=null && this.$store.state.userData.routerList.find((u) => u.routerName == sidebarItems[i].submenu[x].url.replace("/", "")))
        //     {
        //     sidebarFilteredList.push(sidebarItems[i].submenu[x]);
        //     }
        //   }
        // }
        // console.log("sidebarFilteredList", sidebarFilteredList);
        // this.sidebarItemsPropParent = sidebarFilteredList;
        ///

        // sidebarItems.forEach((r) => {
        //   if (r.submenu && this.$store.state.userData.routerList.find((u) => u.routerName == r.url.replace("/", ""))
        //   ) {
        //     sidebarFilteredList.push(r);
        //   }

        // });

        //filter((r) => r.url != null && this.$store.state.userData.routerList.foreEach((p) => p.routerName.includes(r.url.replace("/", ""))));
      }

      // console.log(this.sidebarItemsPropParent);
      // console.log("sidebarItems", sidebarItems);
      // console.log("console.log(this.$store.state.userData.routerList);", this.$store.state.userData.routerList);
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
        this.disableThemeTour = true;
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    BackToTop,
  },
  created() {
    this.GetSidebarItemList();
    this.setSidebarWidth();
    if (this.navbarColor == "#fff" && this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
  },
};
</script>
